export const aiSearch = {
  panel: {
    title: 'AI Search',
    close: 'Close AI Search',
    composerPlaceholder: 'Ask anything',
    send: 'Ask',
    askAnother: 'Ask another question',
    cancel: 'Cancel',
    chatMore: 'Chat more about this',
    chatNote: 'For now, each question is answered on its own.',
    disclaimer: 'Answers come from your own data and permissions. Check anything important.'
  },
  steps: {
    ACCEPTED: 'Getting started…',
    UNDERSTANDING: 'Understanding your question…',
    WRITING_QUERY: 'Writing the search…',
    RETRYING: 'Fixing the search…',
    RUNNING_QUERY: 'Looking up the results…',
    fallback: 'Working…'
  },
  stepsDone: {
    UNDERSTANDING: 'Understood the question',
    WRITING_QUERY: 'Wrote the search',
    RETRYING: 'Fixed the search',
    RUNNING_QUERY: 'Looked up the results'
  },
  answer: {
    showSteps: 'Show steps',
    hideSteps: 'Hide steps',
    tryAgain: 'Try again',
    tryAsking: 'Try asking',
    relatedQuestions: 'Related questions',
    pickPatient: 'Pick the patient you mean',
    born: (date: string) => `Born ${date}`,
    seeAllOn: (page: string) => `See it all on ${page}`,
    noResults: 'Nothing matched.',
    total: (total: number) => `${total} result${total === 1 ? '' : 's'}`,
    showingFirst: (shown: number) => `Showing the first ${shown}`,
    groupedInto: (cards: number) => `${cards} patient${cards === 1 ? '' : 's'}`,
    resultCount: (shown: number, total: number | null) =>
      total !== null && total > shown ? `Showing ${shown} of ${total} results` : `${shown} result${shown === 1 ? '' : 's'}`
  },
  errors: {
    unavailable: 'AI Search is unavailable right now. Please try again.'
  },
  // Signed off by the pharmacy side, and word for word the AI's approved suggestions
  // (ai: ai_search_agent/approved_questions.json): change both together.
  ideas: {
    heading: 'Try asking',
    aboutPatient: (name: string) => `Ask about ${name}`,
    aboutThisPatient: 'Ask about this patient',
    visits: [
      'Who has an appointment today?',
      'Who are the patients with follow-up visits scheduled for today?',
      'Who are the patients with follow-up visits scheduled for tomorrow?',
      'Who are the patients with upcoming follow-up visits this month?',
      'Who are the patients with overdue follow-up visits this month?'
    ],
    alerts: [
      'Who are the patients with No Readings alerts from yesterday?',
      'Who are the patients with critical alerts from yesterday?',
      'Who are the patients with abnormal alerts from yesterday?'
    ],
    tasks: [
      'Who are the patients with pending chart reviews?',
      'Who are the patients with pending alert reviews?',
      'Who are the patients with pending RPM consent?'
    ],
    medRec: ['Who are the patients without new MedRecs this month?', 'Who are the patients with new MedRecs this month?'],
    careTime: ['Who are the patients with less than 20 minutes of care activity time recorded this month?'],
    patient: [
      'Does this patient have any critical alerts?',
      'Show the notes for this patient',
      "What are this patient's diagnoses?",
      'What devices does this patient have?'
    ]
  }
} as const;
